import formatName from "../../helpers/formatName";
import { Grid, TextField } from "@mui/material";
import { toCurrency } from "../../helpers/toCurrency";
import dayjs from "dayjs";
import { Button, Modal } from "../../components";
import { useState } from "react";
import InputMask from "react-input-mask";
import cartoesaceitos from "../../assets/cartoesaceitos.png";
import { InputSelect } from "../../components";
import {
  EditarDadosCartao,
  cadastroCartao,
} from "../../store/actions/cadastro";
import ButtonComponent from "../../components/ButtonComponent";
import { useNavigate } from "react-router-dom";
import { removeDots } from "../../helpers/removeDots";
import Loading from "../../components/Loading";
import AlertComponent from "../../components/AlertComponent";

function TrocarDadosCartao({ usuario, plano, assinatura, loadActions }) {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    numero: "",
    titular: "",
    mes: "",
    ano: "",
  });
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [typeMessageError, setTypeMessageError] = useState("");
  const [messageErrorServer, setMessageErrorServer] = useState("");

  async function ConfirmarAlteracaoCartao() {
    setLoading(true);
    try {
      await EditarDadosCartao({
        numero: removeDots(data.numero),
        titular: data.titular,
        validade: `${data.ano}-${data.mes}`,
      });
      loadActions();
      setOpenModal(false);
      setLoading(false);
      setTypeMessageError("success");
      setMessageAlert("Cartão alterado com sucesso");
      setShowErrorAlert(true);
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 3000);
      setData({});
    } catch (e) {
      setMessageErrorServer(
        e.response.data
          ? e.response?.data?.message
          : "Não foi possível concluir sua solicitação"
      );
      setLoading(false);
      setTypeMessageError("error");
      setMessageAlert("Não foi possível salvar sua solicitação");
      setShowErrorAlert(true);
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 3000);
    }
  }

  function CancelarTroca() {
    setData({});
    setOpenModal(false);
    setMessageErrorServer("");
  }

  return (
    <div style={{ width: "100%" }}>
      <Loading loading={loading} />
      <div style={{ marginTop: 15 }}>
        <h3
          style={{
            fontWeight: "700",
            fontSize: 20,
            margin: 0,
            marginTop: 20,
            color: "#191919",
          }}
        >
          Olá, {formatName(usuario?.nome)}
        </h3>
        <h4
          style={{
            fontWeight: "400",
            fontSize: 16,
            margin: 0,
            color: "#191919",
          }}
        >
          Abaixo os dados da sua assinatura
        </h4>
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <div style={{ marginTop: 30 }}>
              <div style={styles.containerList}>
                <span
                  style={{
                    fontWeight: "700",
                    fontSize: 14,
                    color: "#398A94",
                    background: "#F2F7FA",
                    borderRadius: 7,
                  }}
                >
                  Detalhes referente ao seu plano
                </span>{" "}
                <div style={styles.listaDetalhes}>
                  Plano - {formatName(plano.nome)}
                </div>
                <div style={styles.listaDetalhes}>
                  Permite dependentes -{" "}
                  {plano.permitirDependentes ? "Sim" : "Não"}
                </div>
                <div style={styles.listaDetalhes}>
                  Máximo de dependentes -{" "}
                  {plano.maximoDependentes === 0 ? 0 : plano.maximoDependentes}
                </div>
                <div style={styles.listaDetalhes}>
                  Possui telemedicina - {plano.telemedicina ? "Sim" : "Não"}
                </div>
                <div style={styles.listaDetalhes}>
                  Valor da assinatura - {toCurrency(plano.valor)}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <div>
              <div style={styles.containerList}>
                <span style={styles.titleHeader}>Informações de pagamento</span>{" "}
                <div style={styles.listaDetalhes}>
                  Data de pagamento - {assinatura.getnet.dataPagamento}
                </div>
                <div style={styles.listaDetalhes}>
                  Próximo pagamento -{" "}
                  {dayjs(assinatura.dataProximoPagamento).format("DD/MM/YYYY")}
                </div>
                <div style={styles.listaDetalhes}>
                  Titular - {formatName(assinatura?.getnet?.cartao?.titular)}
                </div>
                <div style={styles.listaDetalhes}>
                  Cartão cadastrado - {assinatura?.getnet?.cartao?.bin} |
                  Bandeira {assinatura?.getnet?.cartao?.bandeira}
                </div>
                <div style={styles.listaDetalhes}>
                  Vencimento cartão - {assinatura?.getnet?.cartao?.validadeMes}/
                  {assinatura?.getnet?.cartao?.validadeAno}
                </div>
                <div style={styles.listaDetalhes}>
                  <button
                    style={{
                      fontWeight: "700",
                      fontSize: 14,
                      color: "#398A94",
                      background: "#F2F7FA",
                      borderRadius: 7,
                      textDecorationLine: "underline",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => !openModal && setOpenModal(true)}
                  >
                    {openModal
                      ? "Digite os novos dados ao lado"
                      : "Alterar cartão de pagamento"}
                  </button>
                </div>
              </div>
            </div>
          </Grid>
          {openModal && (
            <Grid item sm={6} xs={12}>
              <div style={styles.containerList}>
                <span>Digite os dados do novo cartão</span>
                <Grid container spacing={1}>
                  <Grid item sm={6} xs={12}>
                    <span style={styles.titleHeader}>
                      Nome do Titular Impresso no Cartão
                    </span>
                    <TextField
                      value={data.titular}
                      fullWidth
                      size="small"
                      onChange={(e) =>
                        setData({ ...data, titular: e.target.value })
                      }
                      name="titular"
                      inputProps={{ maxlength: 26 }}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <span style={styles.titleHeader}>Número do Cartão</span>

                    <InputMask
                      mask="9999 9999 9999 9999"
                      value={data.numero}
                      onChange={(e) =>
                        setData({ ...data, numero: e.target.value })
                      }
                    >
                      {() => (
                        <TextField
                          placeholder="0000 0000 0000 0000"
                          fullWidth
                          size="small"
                          name="numero"
                        />
                      )}
                    </InputMask>
                  </Grid>

                  <Grid item sm={3} xs={12}>
                    <span style={styles.titleHeader}>Venc. Mês</span>
                    <InputSelect
                      name="mes"
                      values={[
                        { value: "", label: "-" },
                        { value: "01", label: "1" },
                        { value: "02", label: "2" },
                        { value: "03", label: "3" },
                        { value: "04", label: "4" },
                        { value: "05", label: "5" },
                        { value: "06", label: "6" },
                        { value: "07", label: "7" },
                        { value: "08", label: "8" },
                        { value: "09", label: "9" },
                        { value: "10", label: "10" },
                        { value: "11", label: "11" },
                        { value: "12", label: "12" },
                      ]}
                      value={data.mes}
                      onChange={(e) =>
                        setData({ ...data, mes: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <span style={styles.titleHeader}>Venc. Ano</span>
                    <InputSelect
                      name="ano"
                      values={[
                        { value: "", label: "-" },
                        { value: "2023", label: "2023" },
                        { value: "2024", label: "2024" },
                        { value: "2025", label: "2025" },
                        { value: "2026", label: "2026" },
                        { value: "2027", label: "2027" },
                        { value: "2028", label: "2028" },
                        { value: "2029", label: "2029" },
                        { value: "2030", label: "2030" },
                        { value: "2031", label: "2031" },
                        { value: "2032", label: "2032" },
                        { value: "2033", label: "2033" },
                        { value: "2034", label: "2034" },
                        { value: "2035", label: "2035" },
                      ]}
                      value={data.ano}
                      onChange={(e) =>
                        setData({ ...data, ano: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item sm={5} xs={12}>
                    <span style={styles.titleHeader}>Bandeiras aceitas</span>
                    <img
                      src={cartoesaceitos}
                      alt="Bandeiras"
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-around",
                      }}
                    >
                      <button
                        style={styles.buttonCancel}
                        onClick={() => CancelarTroca()}
                      >
                        Cancelar troca
                      </button>
                      <ButtonComponent
                        onClick={() => ConfirmarAlteracaoCartao()}
                      >
                        Salvar novo cartão
                      </ButtonComponent>
                    </div>
                  </Grid>
                </Grid>
              </div>
              {messageErrorServer && (
                <div style={styles.messagesError}>{messageErrorServer}</div>
              )}
            </Grid>
          )}

          {showErrorAlert && (
            <AlertComponent
              type={typeMessageError}
              message={messageAlert}
              timeout={3000}
            />
          )}
        </Grid>
      </div>
    </div>
  );
}

const styles = {
  listaDetalhes: {
    background: "#F8F8F8",
    margin: "10px 0px",
    width: "100%",
    fontSize: 14,
    fontWeight: "400",
  },
  messagesError: {
    background: "#FFF8F6",
    border: "1px solid #FF7752",
    padding: 15,
    color: "#FF7752",
    borderRadius: 14,
    fontSize: 14,
    marginTop: -5,
    marginBottom: 15,
  },
  containerList: {
    border: "1px solid #141414",
    padding: 10,
    borderRight: "4px solid #141414",
    borderBottom: "4px solid #141414",
    borderRadius: 15,
    marginBottom: 30,
  },
  titleHeader: {
    fontWeight: "700",
    fontSize: 14,
    color: "#398A94",
    background: "#F2F7FA",
    borderRadius: 7,
  },
  buttonCancel: {
    border: "none",
    background: "transparent",
    fontWeight: "600",
    textDecorationLine: "underline",
    cursor: "pointer",
  },
};

export default TrocarDadosCartao;
